import { RefreshCw } from "lucide-react";
import { Button } from "./Button";
import { Toast } from "./Toast";

type ApplicationUpdateToastProps = {
  onReload: () => void;
};

export function ApplicationUpdateToast({
  onReload,
}: ApplicationUpdateToastProps) {
  return (
    <Toast
      action={
        <Button onClick={onReload} size="small" type="button">
          Reload application
        </Button>
      }
      icon={<RefreshCw aria-hidden="true" />}
      title="A new version is available"
    >
      Reload the application to use the latest version.
    </Toast>
  );
}
